import { createSlice } from '@reduxjs/toolkit';
import { m } from '../../../utils/date';

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 2,
    }
};

const productInSlice = createSlice({
    name: 'productIn',
    initialState,
    reducers: {
        funGetProductIn(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( productIn ) => {
                const { warehousingDt } = productIn;
                return{
                    ...productIn,
                    warehousingDt: m.date({ value: productIn.warehousingDt }),
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const productInActions = productInSlice.actions;
export default productInSlice.reducer;